<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import { TitleTypography, TypographyItem } from '@/components/Typography'

type Props = {
    latestNews: string[]
}
defineProps<Props>()
</script>

<template>
    <TitleTypography :title="$t('technician.documentation.latestUpdates')" class="title-larger" />
    <StackLayout direction="column">
        <li v-for="(item, key) in latestNews" :key="key" class="latest-news">
            <TypographyItem :label="item" />
        </li>
    </StackLayout>
</template>

<style scoped lang="scss">
.latest-news {
    color: var(--color-text);
}
</style>
